import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// import {
//   addEditData
// } from "../../controllers/speakers/speakers";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
//   const handleChange = (e) => {
//     setAddEditSata((pre) => ({
//       ...pre,
//       [e.target.name]: e.target.value,
//     }));
//     setError((pre) => ({
//       ...pre,
//       [e.target.name]: "",
//     }));
//   };
  /*********************************************************
   *  This function is use to handle image
   *********************************************************/  
//   const  handleImageChnage = (e) => {
//     const fileList = e.fileList.slice(-1); // Keep only the last image
//     setImage(fileList);
//     if (fileList.length === 0) {
//         setError(prev => ({ ...prev, image: "Image is required." }));
//     } else {
//         setError(prev => ({ ...prev, image: "" }));
//     }
// };
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setIsLoading(true);
//     try {
//       const {
//         _id,
//         title,
//         description
//       } = ADDEDITDATA;
//       const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

//       const form = new FormData();
//       if (_id && _id !== "undefined" && _id !== null) {
//         form.append("edit_id", _id);
//       } 
//       form.append("title", title);
//       form.append("description", description);
//       if (image.length > 0) {
//         form.append("image", image[0]?.originFileObj);
//       }
      
//       form.append("ipAddress", ipAddress);

//       const isValidate = validateFormData(form);
// // console.log('isValidate',isValidate);
//       if (isValidate) {
//         const options = {
//           url: "speakers/addeditdata",
//           postData: form,
//         };
//         const res = await addEditData(options);
//         if (res.status === true) {
//           notification.open({
//             message: "Data updated.",
//             description: `Data updated Successfully.`,
//             placement: "topRight",
//             icon: <CheckCircleOutlined style={{ color: "green" }} />,
//             duration: 2,
//           });
//           navigate("/speakers/list");
//         } else {
//           notification.open({
//             message: "Opps!",
//             description: `${res?.message}`,
//             placement: "topRight",
//             icon: <InfoCircleOutlined style={{ color: "red" }} />,
//             duration: 2,
//           });
//         }
//       } else {
//         notification.open({
//           message: "Opps!",
//           description: `Please enter the required fields.`,
//           placement: "topRight",
//           icon: <InfoCircleOutlined style={{ color: "red" }} />,
//         });
//       }
//     } catch (error) {
//       console.log("error", error);
//     }finally{
//       setIsLoading(false);
//     }
//   };


//   const validateFormData = (form) => {
//     if (!form.get("title") || form.get("title") === "undefined" || form.get("title") === null) {
//       notification.error({
//         message: "Validation Error",
//         description: "Title is required",
//       });
//       return false;
//     }

//     if (!form.get("description") ||  form.get("description") === "undefined" || form.get("description") === null) {
//       notification.error({
//         message: "Validation Error",
//         description: "Description is required",
//       });
//       return false;
//     }
//     return true;
//   };


  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = `WaveCompliance || ${ADDEDITDATA?._id ? "View" : "Add"
      } Order`;
  }, []);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `View` : `Add`} Order
            </h5>
          </div>
          <Link to="/orders/list">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    {/* <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="vendor_first_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Title :{" "}
                      </label>
                      <input
                        title="Enter Title."
                        placeholder="Enter Title."
                        type="text"
                        name="title"
                        className="form-control store_input_field"
                        id="title"
                        value={ADDEDITDATA?.title}
                        onChange={handleChange}
                      />
                      {error.title ? (
                        <p style={{ color: "red" }}>
                          {error.title}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-12 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="vendor_email"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Description :
                      </label>
                      <textarea
                        title="Enter Description."
                        placeholder="Enter Description."
                        type="text"
                        name="description"
                        className="form-control store_input_field"
                        id="description"
                        rows={8}
                        value={ADDEDITDATA?.description}
                        // readOnly={ADDEDITDATA?._id ? true : false}
                        onChange={handleChange}
                      />
                      {error.description ? (
                        <p style={{ color: "red" }}>{error.description}</p>
                      ) : (
                        ""
                      )}
                    </div> */}
                    <div className="col-12">
                        <div>
                          <div id="content-wrapper" className="d-flex flex-column">
                            <div className="card shadow mb-4">
                              <div className="card-body pt-0">
                                <div className="table-responsive">
                                  <table
                                    className="table-bordered"
                                    id="dataTable"
                                    width="100%"
                                    cellspacing="0"
                                  >
                                    {/* <thead>
                                      <tr>
                                        <th>Order No</th>
                                        <th>Order total</th>
                                        <th>Discount</th>
                                        <th>Final Amount</th>
                                        <th>Ordered On</th>
                                        <th>Actions</th>
                                      </tr>
                                    </thead> */}
                                    <tbody>
                                        <tr>
                                          <td><b>Order no</b></td>
                                          <td>{ADDEDITDATA?.order_no}</td>
                                        </tr>
                                        <tr>
                                          <td><b>User Contact</b></td>
                                          <td>
                                            {ADDEDITDATA?.user_id.first_name} {" "}
                                            {ADDEDITDATA?.user_id.last_name}<br/>
                                            {ADDEDITDATA?.user_id.email}<br/>
                                            {ADDEDITDATA?.user_id.phone}<br/>
                                            {ADDEDITDATA?.user_id.company}<br/>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td><b>Order total</b></td>
                                          <td>${ADDEDITDATA?.order_total}</td>
                                        </tr>
                                        <tr>
                                          <td><b>Coupon Discount (if any)</b></td>
                                          <td>${ADDEDITDATA?.couponDiscount ?? 0}</td>
                                        </tr>
                                        <tr>
                                          <td><b>Coupon Used (if any)</b></td>
                                          <td>{ADDEDITDATA?.couponUsed ?? "-"}</td>
                                        </tr>
                                        <tr>
                                          <td><b>Amount Paid</b></td>
                                          <td>{ADDEDITDATA?.finalAmount}</td>
                                        </tr>
                                        {/* <tr>
                                          <td><b>Order Status</b></td>
                                          <td>{ADDEDITDATA?.order_status}</td>
                                        </tr> */}
                                        <tr>
                                          <td><b>Payment Status</b></td>
                                          <td>{ADDEDITDATA?.payment_status}</td>
                                        </tr>
                                        <tr>
                                          <td><b>Billing Info</b></td>
                                          <td>
                                            {ADDEDITDATA?.billing_addlineone}<br/>
                                            {ADDEDITDATA?.billing_addlinetwo}<br/>
                                            {ADDEDITDATA?.billing_zipcode}<br/>
                                            {ADDEDITDATA?.billing_city}<br/>
                                            {ADDEDITDATA?.billing_state}<br/>
                                            {ADDEDITDATA?.billing_country}<br/>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td><b>Shipping Info</b></td>
                                          <td>
                                            {ADDEDITDATA?.shipping_addlineone}<br/>
                                            {ADDEDITDATA?.shipping_addlinetwo}<br/>
                                            {ADDEDITDATA?.shipping_zipcode}<br/>
                                            {ADDEDITDATA?.shipping_city}<br/>
                                            {ADDEDITDATA?.shipping_state}<br/>
                                            {ADDEDITDATA?.shipping_country}<br/>
                                          </td>
                                        </tr>
                                        <tr>
                                            <div className="mt-5" style={{fontSize:"24px"}}><b>Order Items</b></div>
                                        </tr>
                                        <tr>
                                                    <td><b>Webinar</b></td>
                                                    <td><b>Price</b></td>
                                                    <td><b>Quantity</b></td>
                                                    <td><b>Price</b></td>
                                                </tr>
                                        {ADDEDITDATA.order_items.map((items, index) => (
                                            <tr>
                                                <td>{items?.product_name}<br/><b>Type :-</b> {items?.variant_name}</td>
                                                <td>{items?.price}</td>
                                                <td>{items?.quantity}</td>
                                                <td>{items?.total}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div> 
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
